import FilterOperator from "../../Filters/FilterOperator";
import FilterPropertyType from "../../Filters/FilterPropertyType";
import FilterPropertyRenderType from "../../Filters/FilterPropertyRenderType";

import FlagHelper from "../../Helpers/FlagHelper";

const filterProperties = [
	{
		name: "Flag",
		key: "flag",
		type: FilterPropertyType.ENUM,
		typeData: {
			renderType: FilterPropertyRenderType.FLAG,
			options: FlagHelper.getAllFlagCodes()
		},
		operators: [FilterOperator.IS]
	},
	{
		name: "Vessel Type",
		key: "vesselType",
		type: FilterPropertyType.ENUM,
		typeData: {
			options: ["cargo", "fishing", "passenger", "pleasure craft", "sailing", "tanker", "tug", "other"]
		},
		operators: [FilterOperator.IS]
	}
];
export default filterProperties;
